<script>
    import { _ } from 'svelte-i18n';
    import Icon from './Icon.svelte';
    import arrowLeftIcon from '../assets/icons/arrow-left.svg?raw';

    const { onclick } = $props();

</script>

<button type="button" {onclick}>
    <Icon data={arrowLeftIcon} />
    <span>{$_('back')}</span>
</button>

<style>
    button {
        display: inline-flex;
        align-items: center;
        
        color: var(--text-color);
        background: none;
        border: none;
        padding: 0;
        margin-top: 0.3rem;
        margin-bottom: 1.5rem;
        gap: 0.3em;

        font-size: 0.8rem;

        cursor: pointer;
    }

    button :global(svg) {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    button span {
        font-size: inherit;
        line-height: 1;
    }
</style>